
<p-toolbar
  *ngIf="isLogged && router.url !== '/infoPage'"
  [hidden]="!isShown"
>
  <div class="p-toolbar-group-start">

    <img
      class="toolbar-logo"
      src="./assets/logos/faisa-cisal-logo.svg"
      alt="Logo FAISA CISAL"
    />

    <p-divider
      layout="vertical"
      styleClass="toolbar-divider"
    ></p-divider>

    <p-button
      [routerLink]="['/home']"
      icon="pi pi-home"
      styleClass="toolbar-action-button"
    ></p-button>

    <p-button
      (onClick)="openOrgChartView()"
      icon="pi pi-phone"
      styleClass="toolbar-action-button"
    ></p-button>

  </div>

  <div class="p-toolbar-group-end">
    <p-button
      (onClick)="logout()"
      icon="pi pi-power-off"
      severity="danger"
      styleClass="toolbar-action-button"
    ></p-button>
  </div>
</p-toolbar>

<div
  *ngIf="isShown && isLogged && !isInfoPage"
  class="declaration py-3 flex justify-content-center flex-wrap"
>
  <strong class="text-sm">
    Segreteria Provinciale di Pistoia
  </strong>
</div>

<div
  [ngClass]="{
    'mt-3': !isInfoPage,
    'main-content-desktop': !isSmartphone && !isInfoPage,
    'main-content-mobile': isSmartphone && !isInfoPage,
    'public-page-container': isInfoPage
  }"
>
  <router-outlet></router-outlet>
</div>

<p-toast
  position="bottom-center"
  key="bc"
></p-toast>

<!-- =====================================================
     DIALOG CONTATTI
     Chiusura tramite X in alto a destra
     ===================================================== -->

<p-dialog
  [(visible)]="isVisible"
  [closable]="true"
  [draggable]="false"
  [modal]="true"
  [closeOnEscape]="true"
  #cd
>
  <ng-template pTemplate="header">
    <h2>Contatti</h2>
  </ng-template>

  <ng-template pTemplate="message">
    <div class="flex flex-column gap-3">
      <ng-container *ngFor="let item of contacts">
        <div>
          <i
            class="pi pi-{{item.icon}} mr-1"
            style="font-size: 1.2rem"
          ></i>

          <span>
            {{item.contact}} - {{item.description}}
          </span>
        </div>
      </ng-container>
    </div>
  </ng-template>
</p-dialog>
